<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="名称" prop="honorName">
          <a-input v-model="form.honorName" />
        </a-form-model-item>
        <a-form-model-item label="年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="数量" prop="amount">
          <a-input-number
            v-model="form.amount"
            min="1"
            precision="0"
            @blur="blurValue"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        honorName: "",
        acquireYear: "",
        amount: "",
      },
      rules: {
        honorName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        acquireYear: [
          {
            required: true,
            message: "请选择荣誉获得年份",
            validator: (rule, value, callback) => {
              
              if (this.form.acquireYear!='') {
                callback(); // 验证通过
              } else {
                callback(new Error('请选择荣誉获得年份'));
              }
            },
            //          type: 'string',
            trigger: "change",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        amount: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      // xwlist: [],
      // jblist: [],
      // kclist: [],
      // ishow: false,
      // declareType: 1
    };
  },
  components: { BaseEditor },
  mounted() {
  },
  methods: {
    handleClearAcquireYear(val) {
      this.form.acquireYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      const year = moment(value).format('YYYY');
      this.form.acquireYear =year+"";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("acquireYear");
     
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      if (type == "add") {
        this.form = {};
        // this.form.applyId = record.id;
        this.title = "新增荣誉";
        this.form.acquireYear=new Date().getFullYear()+"";
      } else {
        this.title = "编辑荣誉";
        const { honorName, acquireYear, amount,id } = record;
        this.form = {
          honorName,
          acquireYear,
          amount,
          id
        };
      }
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
     
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != "" 
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            if(this.$parent.oldInfos?.id){
               let params = {
                ...this.form,
                applyType: this.applyType,
                // applyId: "1829722136428707841",
                declareType: this.declareType,
                applyId:this.$parent.oldInfos?.id,
              };
               postAction("/lx/lxHonor/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain",{});
              } else {
                this.$message.error(res.message);
              }
            });
            }else{
              let params = {
              ...this.form,
              };
              this.visible = false;
              this.$message.success("添加成功");
              this.$emit("addGain",{record:params,type:'add'});
            }
            
           
          } else {
            if(this.$parent.oldInfos?.id){
                let params = {
                ...this.form,
                applyType: this.applyType,
                // applyId: "1829722136428707841",
                declareType: this.declareType,
                applyId:this.$parent.oldInfos?.id,
              };
                putAction("/lx/lxHonor/edit", params).then((res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain",{});
                  } else {
                    this.$message.error(res.message);
                  }
                });
            }else{
              let params = {
              ...this.form,
              // declareType: this.declareType
            };
            if (typeof this.form.acquireYear == "object") {
              params.acquireYear =
                new Date(this.form.acquireYear).getFullYear() + "";
            }
            this.visible = false;
            this.$message.success("编辑成功");
            this.$emit("addGain",{record:params,type:'edit'});
            }
            
           
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
  